module.exports = __webpack_public_path__ + "static/media/benefits6.686862d1.png";